export default "__VITE_ASSET__i$QplP_B__"